import React from 'react'
import Image from 'next/image'
// import { MediaPosterImage } from 'media-chrome/react';

export default function MediaPoster ({
  ...props
}) {
  // handle the poster image according to the aspect ratio add query paremeter ar:<aspect-ratio> and mpde=crop
  let poster
  if ((props?.width || props?.height) && props?.poster) {
    const parsedUrl = new URL(props?.poster)
    parsedUrl.searchParams.set('ar', `${props.width}:${props.height}`)
    parsedUrl.searchParams.set('mode', 'crop')
    poster = parsedUrl.toString()
  } else {
    poster = props?.poster
  }

  let style = {}

  if (props.isToolsPage || props.isVideoCenterAligned) {
    style = {
      ...style,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }

  return (
    props.poster && (
      <Image
        slot='poster'
        src={poster}
        alt='Poster image'
        style={style}
        width={1200}
        height={700}
        priority
        sizes='100vw'
      />
    )
  )
}
